import { styled } from '@mui/material/styles';
import { EyeSlashIcon } from '@phosphor-icons/react/EyeSlash';

import { GAP_SIZE, TextVariant } from './constants.ts';

export const StyledErrorIcon = styled(EyeSlashIcon, {
  shouldForwardProp: prop => prop !== 'paddingVariant' && prop !== 'isPointer',
})<{
  paddingVariant: TextVariant;
  width: number;
  height: number;
  isPointer?: boolean;
}>`
  box-sizing: content-box;
  cursor: ${({ isPointer }) => isPointer && 'pointer'};
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
  padding-right: ${({ paddingVariant }) => `${paddingVariant === TextVariant.Horizontal ? GAP_SIZE : 0}px`};
  padding-bottom: ${({ paddingVariant }) => `${paddingVariant === TextVariant.Vertical ? GAP_SIZE : 0}px`};
  color: ${({ theme }) => theme.palette.text.disabled};
`;
